import { APIClient } from '@0xsplits/spectatscode/src/metrics/api.client'
import { TwirpFetchTransport } from '@protobuf-ts/twirp-transport'

export const API = new APIClient(
  new TwirpFetchTransport({
    // We guard against SPECTA_ENDPOINT being undefined when we use the API.
    // see: utils/specta/metrics/postHistogram.ts

    // This allows us to use the app locally with or without SPECTA_ENDPOINT set.
    // and without seeing constant errors in the console.
    baseUrl: process.env.SPECTA_ENDPOINT || '',
    sendJson: true,
  }),
)
